let cache = null;
let loadingPromise = null;

/**
 * Lazy-load English editorial bodies (split from main bundle for FR visitors).
 * @returns {Promise<Record<string, object>>}
 */
export function loadContentEnBodies() {
  if (cache) {
    return Promise.resolve(cache);
  }

  if (!loadingPromise) {
    loadingPromise = import('./contentEnBodies')
      .then((module) => {
        cache = module.default;
        return cache;
      })
      .catch((error) => {
        loadingPromise = null;
        throw error;
      });
  }

  return loadingPromise;
}

/**
 * @returns {Record<string, object> | null}
 */
export function getContentEnBodiesSync() {
  return cache;
}
